import { render, staticRenderFns } from "./TestCenter.vue?vue&type=template&id=1985f960&scoped=true&"
import script from "./TestCenter.vue?vue&type=script&lang=js&"
export * from "./TestCenter.vue?vue&type=script&lang=js&"
import style0 from "./TestCenter.vue?vue&type=style&index=0&id=1985f960&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985f960",
  null
  
)

export default component.exports